let formatter = new Intl.NumberFormat()

export function parseMoney(amount) {
    return formatter.format(amount)
}

export function strToFloatMoney(s) {
    return parseFloat(s.replace(/\s/g, '').replace(/,/g, '.'))
}